import React, { FC } from 'react';
import { PrismicFileSlice } from '@modules/visits/model';
import SliceLayout from '@modules/visits/components/tag/slice/common/SliceLayout';

import * as Styled from './FileSlice.styles';

import downloadIconVegetag from '@assets/icons/tag/download.png';
import downloadIconArcachon from '@assets/icons/tag/arcachon.download.png';
import { selectAsset } from '@shared/utils/assets';

const downloadIcon = selectAsset(downloadIconVegetag, downloadIconArcachon);

interface FileSliceProps {
  slice: PrismicFileSlice;
}

const FileSlice: FC<FileSliceProps> = ({ slice }) => {
  return (
    <SliceLayout title={slice.primary.app_file_title}>
      <Styled.FileSliceContainer>
        {slice.items.map((item, i) => (
          <a key={i} href={item.app_file?.url} target="_blank" rel="noopener noreferrer">
            <img src={downloadIcon} width={28} height={27} alt="Download" />

            <span>{item.app_file_name}</span>
          </a>
        ))}
      </Styled.FileSliceContainer>
    </SliceLayout>
  );
};

export default FileSlice;
